import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { use } from 'react';

import { TradingLeaderboardInterval } from '@flipster/apis/v2/trading-leaderboards/types';
import { createTabsComponent } from '@flipster/react/design-system/tabs';
import { css } from '@flipster/styled-system/css';
import segment from '@flipster/utils/segment';
import { TradingLeaderboardEvent } from '@flipster/utils/segment/events/trading-leaderboard';

import { LeaderboardContext, tradingLeaderboardMyRankingBunja } from '../bunja';

const Tabs = createTabsComponent<TradingLeaderboardInterval>();

export const IntervalTabs = () => {
  const t = useTranslations();
  const router = useRouter();
  const { interval } = use(LeaderboardContext);
  const { myOptInIntervalRankingsAtom } = useBunja(tradingLeaderboardMyRankingBunja);
  const myOptInRank = useAtomValue(myOptInIntervalRankingsAtom);
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  const handleTabClick = (next: TradingLeaderboardInterval) => {
    if (interval === next) return;
    const tier = myOptInRank[next]?.tier ?? 'ALL';
    router.push(`?interval=${next}&tier=${tier}`);
    scrollToTop();
    segment.track(TradingLeaderboardEvent.LeaderboardTypeClick, { interval: next });
  };
  return (
    <div
      className={css({ pos: 'sticky', top: '{sizes.navigationHeight}', bg: 'background.default.level-0', zIndex: 1 })}
    >
      <Tabs type='scrollable' value={interval} onChange={handleTabClick}>
        <Tabs.Tab value='WEEKLY' label={t('Navigation.r250401.Weekly')} />
        <Tabs.Tab value='MONTHLY' label={t('Navigation.r250401.Monthly')} />
      </Tabs>
    </div>
  );
};
